export function isCategoryInDepends(subcategories, category) {
  return subcategories.some((subcategory) => subcategory.depends === category)
}
